import React, { useRef } from "react";
import { TextField, TextFieldProps } from "@mui/material";

/**
 * Number TextField that does not change its value when the mouse wheel is scrolled
 * while the input is focused. The input is blurred so subsequent wheel events
 * scroll the page instead.
 */
const NumberField = (props: TextFieldProps) => {
  const { inputRef: inputRefProp, ...rest } = props;
  const removeWheelListenerRef = useRef<(() => void) | null>(null);

  /**
   *
   * @param node
   * @returns
   */
  const assignInputRef = (node: HTMLInputElement | null) => {
    removeWheelListenerRef.current?.();
    removeWheelListenerRef.current = null;

    if (typeof inputRefProp === "function") {
      inputRefProp(node);
    } else if (inputRefProp) {
      // Hand the input element to whoever passed inputRef, so they can use it too
      // Without this, other code could not get hold of this field (e.g. to focus it)
      (inputRefProp as React.MutableRefObject<HTMLInputElement | null>).current = node;
    }

    if (!node) {
      return;
    }

    const handleWheel = (event: WheelEvent) => {
      if (document.activeElement === node) {
        event.preventDefault();
        node.blur();
      }
    };

    node.addEventListener("wheel", handleWheel, { passive: false });
    removeWheelListenerRef.current = () => {
      node.removeEventListener("wheel", handleWheel);
    };
  };

  return <TextField {...rest} type="number" inputRef={assignInputRef} />;
};

export default NumberField;
